export default "__VITE_ASSET__Dm8VpRx0__"